import $http from '@/api/index'
import {
  getToken
} from '../../../util/auth'
const cookieUser = getToken()
//TODO:获取审批
export function GetAllApproveTask() {
  let options = {
    method: 'GET',
    url: 'Task/GetAllApproveTask',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//TODO:通过任务类型获取任务设置
export function GetTaskSettingByTaskType(tasktype, taskclass) {
  let options = {
    method: 'GET',
    url: 'Task/GetTaskSettingByTaskType',
    requestType: 2
  }
  let params = {
    tasktype: tasktype,
    taskclass: taskclass
  }
  return $http(options, params)
}

//TODO:通过任务类型获取任务设置
export function GetAllTaskSetting() {
  let options = {
    method: 'GET',
    url: 'Task/GetAllTaskSetting',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}

//TODO:通过任务ID获取任务对应业务信息
export function GetTaskBusinessByTaskId(taskid) {
  let options = {
    method: 'GET',
    url: 'Task/GetTaskBusinessByTaskId?taskid=' + taskid,
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}
//TODO:通过任务类型获取不同任务状态的相关设置
export function GetTaskStateSettingByTaskType(tasktype, taskclass, taskstate) {
  let options = {
    method: 'GET',
    url: 'Task/GetTaskStateSettingByTaskType',
    requestType: 2
  }
  let params = {
    tasktype: tasktype,
    taskclass: taskclass,
    taskstate: taskstate
  }
  return $http(options, params)
}
//TODO:审核任务
export function ApproveTask(approveInfo) {
  let options = {
    method: 'POST',
    url: 'Task/ApproveTask',
    requestType: 2
  }
  let params = approveInfo
  return $http(options, params)
}
//TODO:执行命令任务
export function CmdExcuteTask(cmdInfo) {
  let options = {
    method: 'POST',
    url: 'Task/CmdExcuteTask',
    requestType: 2
  }
  let params = cmdInfo
  return $http(options, params)
}

//TODO:获取USB信息
export function GetUnAuditUsbDeviceById(id) {
  let options = {
    method: 'GET',
    url: 'POLICY/GetUnAuditUsbDeviceById',
    requestType: 2
  }
  let params = {
    id: id
  }
  return $http(options, params)
}
//TODO:获取所有任务状态设置
export function GetAllTaskStateSetting() {
  let options = {
    method: 'GET',
    url: 'Task/GetAllTaskStateSetting',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}

//TODO:获取所有任务状态设置
export function Get() {
  let options = {
    method: 'GET',
    url: 'Task/GetAllTaskStateSetting',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}

/**
 * 获取所有任务类型视图方式
 */
export function GetAllTaskTypeView() {
  let options = {
    method: 'GET',
    url: 'Task/GetAllTaskTypeView',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}

/**
 * 获取所有任务类型包含的视图展示方式
 */
export function GetAllTaskTypeByView() {
  let options = {
    method: 'GET',
    url: 'Task/GetAllTaskTypeByView',
    requestType: 2
  }
  let params = {}
  return $http(options, params)
}

export function GetTaskTypeViewByTypeId(typeId) {
  let options = {
    method: 'GET',
    url: 'Task/GetTaskTypeViewByTypeId',
    requestType: 2
  }
  let params = {
    typeId: typeId
  }
  return $http(options, params)
}

/**
 * 修改任务操作周期时间
 * @param {*} TaskId 
 * @param {*} TimeNum 
 * @param {*} TimeUnit 
 * @param {*} Person 
 */
export function UpdateTaskResponseTime(TaskId, TimeNum, TimeUnit, Person) {
  let options = {
    method: 'POST',
    url: 'Task/UpdateTaskResponseTime',
    requestType: 2
  }
  let params = {
    TaskId: TaskId,
    TimeNum: TimeNum,
    TimeUnit: TimeUnit,
    Person: Person
  }
  return $http(options, params)
}

/**
 * 修改任务等级
 * @param {*} TaskId 
 * @param {*} TaskDegree 
 * @param {*} Person 
 */
export function UpdateTaskDegree(TaskId, TaskDegree, Person) {
  let options = {
    method: 'POST',
    url: 'Task/UpdateTaskDegree',
    requestType: 2
  }
  let params = {
    TaskId: TaskId,
    TaskDegree: TaskDegree,
    Person: Person
  }
  return $http(options, params)
}

/**
 * 获取任务子集
 * @param {*} taskId 
 * @param {*} userId 
 */
export function GetSubTaskTreePathByTaskId(taskId, userId) {
  let options = {
    method: 'GET',
    url: 'Task/GetSubTaskTreePathByTaskId',
    requestType: 2
  }
  let params = {
    taskId: taskId,
    userId: userId
  }
  return $http(options, params)
}

/**
 * 修改文件夹/群组名称
 * @param {*} params 
 */
export function UpdateTreePathName(params) {
  let options = {
    method: 'POST',
    url: 'Task/UpdateTreePathName',
    requestType: 2
  }
  return $http(options, params)
}
/**
 *保存基础任务类型配置
 *
 * @export
 * @param {*} setting
 * @returns
 */
export function SaveTaskSetting(setting) {
  let options = {
    method: 'POST',
    url: 'Task/SaveTaskSetting',
    requestType: 2
  }
  return $http(options, setting)
}

/**
 *保存基础任务类型状态配置
 *
 * @export
 * @param {*} setting
 * @returns
 */
export function SaveTaskStateSetting(setting) {
  let options = {
    method: 'POST',
    url: 'Task/SaveTaskStateSetting',
    requestType: 2
  }
  return $http(options, setting)
}
/**
 * @description  基础类型任务插入
 * @constructor
 */
export function InsertBaseTask(baseTask) {
  let options = {
    method: "POST",
    url: "task/InsertBaseTask",
    requestType: 2,
  };
  return $http(options, baseTask);
}